import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import "./index.css";
import "./i18n"; // ✅ Initialisation i18next avant tout rendu

// ✅ Création du root React 18+
const root = createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    {/* 🧩 Contexte global d’authentification */}
    <AuthProvider>
      {/* 🌐 Router principal */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

registerSW({
  immediate: true,
});